import type { ComponentProps } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Clickable from 'components/Common/Clickable'
import Caption from 'LuxKit/Typography/Caption'
import Heading from 'LuxKit/Typography/Heading'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import AIGlowBorder from './AIGlowBorder'

const DESCRIPTION_SEPARATOR = '•'

const EditContainer = styled(Clickable)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${rem(8)};
  width: 100%;
  min-width: 0;
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

const DescriptionSeparator = styled.span`
  margin: 0 ${rem(8)};
`

const StyledLineSearchIcon = styled(LineSearchIcon)`
  flex: 0 0 auto;
`

function Description({ primaryText, secondaryText, separator = DESCRIPTION_SEPARATOR, variant = 'large' }: { primaryText: string, secondaryText?: string, separator?: string, variant?: ComponentProps<typeof Caption>['variant'] }) {
  const content = secondaryText ? (
    <>
      {primaryText}
      <DescriptionSeparator>{separator}</DescriptionSeparator>
      {secondaryText}
    </>
  ) : primaryText

  return <Caption variant={variant} wrap="truncate">{content}</Caption>
}

export function SearchBarSummary({ label, primaryText, secondaryText, separator, descriptionVariant }: { label: string, primaryText: string, secondaryText?: string, separator?: string, descriptionVariant?: ComponentProps<typeof Caption>['variant'] }) {
  return (
    <TextContainer>
      <Heading variant="heading6" wrap="truncate">{label}</Heading>
      <Description primaryText={primaryText} secondaryText={secondaryText} separator={separator} variant={descriptionVariant} />
    </TextContainer>
  )
}

interface Props extends ComponentProps<typeof SearchBarSummary> {
  onEdit: () => void
}

function MobileHotelSearchSummaryBar({ onEdit, ...summaryProps }: Props) {
  return (
    <AIGlowBorder>
      <EditContainer onClick={onEdit}>
        <SearchBarSummary {...summaryProps} />
        <StyledLineSearchIcon size={20} />
      </EditContainer>
    </AIGlowBorder>
  )
}

export default MobileHotelSearchSummaryBar
